import { hideLoader, showLoader } from "@/store/slices/loaderSlice";
import { BaseService } from "./base.service";
import { store } from "@/store/store";
import { api } from "@/lib/api";
import ToastService from "@/utils/toast";
import { ApiResponse } from "@/interfaces/api.interface";
import { IArea, ILevel } from "@/interfaces/level.interface";

export class LevelService extends BaseService {
  constructor() {
    super("Level");
  }

  async createLevel(name: string, projectId: string, file: any) {
    try {
      store.dispatch(showLoader());

      const formData = new FormData();
      formData.append("File", file);
      formData.append("LevelName", name);
      formData.append("ProjectId", projectId);

      const res: any = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/Level/create-level`,
        formData
      );
      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  async uploadImage(levelId: string, file: any) {
    try {
      store.dispatch(showLoader());

      const formData = new FormData();
      formData.append("File", file);
      formData.append("Id", levelId);

      const res: any = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/Level/upload-image`,
        formData
      );
      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  async fetchAreasByLevel(
    levelId: string,
    version: number,
    userIds: string | null,
    statuses: string | null
  ): Promise<ApiResponse<IArea[]>> {
    try {
      const res: any = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/Level/areas-by-level/${levelId}?version=${version}&userIds=${userIds}&statuses=${statuses}`
      );

      if (res.ok) {
        return {
          data: res.data,
          error: null,
        };
      }

      throw new Error(
        res.data?.message || "An error occurred while fetching areas"
      );
    } catch (error) {
      return {
        data: null,
        error: {
          message:
            (error as string) || "An error occurred while fetching areas",
        },
      };
    }
  }

  async getHistoryByLevelId(levelId: string): Promise<ApiResponse<ILevel[]>> {
    try {
      const res: any = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/Level/history-by-levelid/${levelId}`
      );

      if (res.ok) {
        return {
          data: res.data,
          error: null,
        };
      }

      throw new Error(
        res.data?.message || "An error occurred while fetching areas"
      );
    } catch (error) {
      return {
        data: null,
        error: {
          message:
            (error as string) || "An error occurred while fetching areas",
        },
      };
    }
  }

  async getDistinctActiveLevelNames(projectId: string): Promise<ApiResponse<string[]>> {
    try {
      const res: any = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/lookups/distinct-active-level-names/${projectId}`
      );

      if (res.ok) {
        return {
          data: res.data,
          error: null,
        };
      }

      throw new Error(
        res.data?.message || "An error occurred while fetching level names"
      );
    } catch (error) {
      return {
        data: null,
        error: {
          message:
            (error as string) || "An error occurred while fetching level names",
        },
      };
    }
  }
}

export const levelSvc = new LevelService();
